export const GET_PROGRESS_USERS = 'GET_PROGRESS_USERS'
export const GET_COWORKER_ACCESS_USERS_COUNT = 'GET_COWORKER_ACCESS_USERS_COUNT'

export const GET_USERS_FROM_SEARCH = 'GET_USERS_FROM_SEARCH'
export const GET_USER_EMPLOYEE_FOR_TREE = 'GET_USER_EMPLOYEE_FOR_TREE'

export const GET_USER_FORM_GROUP = 'GET_USER_FORM_GROUP'
